module.exports = __webpack_public_path__ + "img/exclamation-circle.19d6880e.svg";